
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"columnChart":"Säulendiagramm","error":"Beim Erstellen der neuen Sicht ist ein Fehler aufgetreten","map":"Karte","other":"Sonstige ...","table":"Tabelle (gruppiert)","text":"Text"},"en":{"columnChart":"Column chart","error":"An error occurred while creating a new view","map":"Map","other":"Other ...","table":"Table (grouped)","text":"Text"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();